import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { Subspace } from '~src/spacesPlatform/components/spaceComponents/TabbedSpace';

import { IAdminPermission, IAdminProfileDetails } from '../models/IAdminProfile';
import { AdminProfilePermissionsTab } from './tabs/AdminProfilePermissionsTab';
import { AdminProfileSitesTabProvider } from './tabs/AdminProfileSitesTabProvider';
import { AdminProfileUsersTabProvider } from './tabs/AdminProfileUsersTabProvider';
import { AdminProfileServerUser } from './tabs/AdminProfileUsersTabProvider';

function getEnabledPermissionCount(permissions: ReadonlyArray<IAdminPermission>): number {
  return permissions.filter(p => p.enabled).length;
}

/**
 * Generates the subspace configuration for admin profile tabs
 * @param profile The admin profile details
 * @param onProfileSitesUpdated Callback when profile sites/users are updated
 * @param adminProfileSystemUsers Users deduplicated by systemId (for Users tab)
 * @returns Array of subspace configurations for TabbedSpace
 */
export function getAdminProfileSubspaces(
  profile: IAdminProfileDetails,
  onProfileSitesUpdated: () => void,
  adminProfileSystemUsers: ReadonlyArray<AdminProfileServerUser>
): ReadonlyArray<Subspace> {
  return [
    {
      name: 'permissions',
      tabLabel: Messages.adminProfileTabPermissions(),
      renderContent: () => <AdminProfilePermissionsTab permissions={profile.permissions} />,
      shouldRenderTabContentCount: true,
      tabContentCount: getEnabledPermissionCount(profile.permissions),
      tabContentCountUpToDate: true,
    },
    {
      name: 'sites',
      tabLabel: Messages.adminProfileTabSites(),
      renderContent: () => (
        <AdminProfileSitesTabProvider
          sites={profile.sites}
          profileId={profile.luid}
          profileName={profile.name}
          onProfileSitesUpdated={onProfileSitesUpdated}
        />
      ),
      shouldRenderTabContentCount: true,
      tabContentCount: profile.sites?.length || 0,
      tabContentCountUpToDate: true,
    },
    {
      name: 'users',
      tabLabel: Messages.adminProfileTabUsers(),
      renderContent: () => (
        <AdminProfileUsersTabProvider
          users={adminProfileSystemUsers}
          profileId={profile.luid}
          profileName={profile.name}
          onProfileUsersUpdated={onProfileSitesUpdated}
        />
      ),
      shouldRenderTabContentCount: true,
      tabContentCount: adminProfileSystemUsers.length,
      tabContentCountUpToDate: true,
    },
  ];
}
